import { Controller, useFormContext } from 'react-hook-form';
import { DashboardPageFormBody, DashboardPageFormField } from '@shigo-ui/dashboard-ui';
import { Input } from '@shigo-ui/ui';

import { dashboardT, type DashboardMessageKey } from '../../../../../lib/messages';
import type { NetworkFormValue } from '../../networkFormSchema';

const regionFields = [
  ['platformName', 'networks.region.platformName', true],
  ['rootDomain', 'networks.region.rootDomain', true],
  ['exchangeBidderName', 'networks.region.exchangeBidderName', true],
  ['backendDomain', 'networks.region.backendDomain', false],
  ['exchangeDomain', 'networks.region.exchangeDomain', false],
  ['trackersDomain', 'networks.region.trackersDomain', false],
  ['cdn', 'networks.region.cdn', false],
  ['a2v', 'networks.region.a2v', false],
  ['tagId', 'networks.region.tagId', false],
  ['logoUrl', 'networks.region.logoUrl', false],
  ['logoLightUrl', 'networks.region.logoLightUrl', false],
  ['faviconUrl', 'networks.region.faviconUrl', false],
  ['supportEmail', 'networks.region.supportEmail', false],
  ['s3bucketDo', 'networks.region.s3bucketDo', false],
  ['cdnDo', 'networks.region.cdnDo', false],
  ['rosConfig', 'networks.region.rosConfig', false],
] as const satisfies readonly (readonly [
  keyof NetworkFormValue['us'],
  DashboardMessageKey,
  boolean,
])[];

export function NetworkRegionFields({ region }: { region: 'us' | 'eu' }) {
  'use no memo';
  const { control } = useFormContext<NetworkFormValue>();
  return (
    <DashboardPageFormBody width="lg">
      <div className="grid gap-5 md:grid-cols-2">
        {regionFields.map(([fieldName, labelKey, required]) => {
          const name = `${region}.${fieldName}` as const;
          const id = `network-${region}-${fieldName}`;
          return (
            <Controller
              key={name}
              control={control}
              name={name}
              render={({ field, fieldState }) => (
                <DashboardPageFormField
                  label={dashboardT(labelKey)}
                  htmlFor={id}
                  required={required}
                  error={fieldState.error?.message}
                >
                  <Input
                    {...field}
                    id={id}
                    type={fieldName === 'tagId' ? 'number' : 'text'}
                    min={fieldName === 'tagId' ? '0' : undefined}
                    required={required}
                    aria-invalid={Boolean(fieldState.error)}
                  />
                </DashboardPageFormField>
              )}
            />
          );
        })}
      </div>
    </DashboardPageFormBody>
  );
}
